import React from "react"
import { Box } from "@mui/material"
import ReportManualExecutionSwitch from "./ManualExecution"
import ReportFrequencyHoursField from "./FrequencyHours"
import ReportFrequencyDaysField from "./FrequencyDays"
import MultipleModalFrequencyInfoSection from "Pages/ReportsAlerts/Reports/@components/MultipleModal/Content/FrequencySection/Info"


export default function ReportMultiModalFrequencySection() {

	return <>
		<ReportManualExecutionSwitch/>
		<Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mt: 2.5 }}>
			<ReportFrequencyHoursField/>
			<ReportFrequencyDaysField/>
		</Box>
		<MultipleModalFrequencyInfoSection/>
	</>
}
